import { colors, contrast } from '../colors';
import { createThemeMode } from './common';

export const darkTheme = createThemeMode(
  'dark',
  {
    primary: colors.white,
    secondary: colors.brandBlack,
    textPrimary: colors.lighterGrey,
    textSecondary: colors.mediumGrey,
    textDisabled: colors.mediumGrey2,
    textIcon: colors.lightestGrey,
    backgroundMain: colors.black,
    backgroundPaper: colors.brandBlack,
    backgroundGradient: `linear-gradient(225deg, ${colors.darkestGrey} 0%, ${colors.black} 100%)`,
    inputPlaceholder: colors.mediumGrey2,
    menuItemFocused: colors.darkestGrey,
    divider: colors.darkestGrey,
    contrast: [...contrast].reverse(),
  },
  {
    2: '0px 2px 8px rgba(255, 255, 255, 0.08)',
    3: '0px 2px 8px rgba(255, 255, 255, 0.16)',
    /**
     * Index 4: dark counterpart of the light "Shadow/elevation-small" (Figma node 25757:134720).
     * Same offsets and blur, white tint, like indexes 2 and 3.
     */
    4: '0px 1px 3px rgba(255, 255, 255, 0.08), 0px 3px 6px rgba(255, 255, 255, 0.08)',
  },
);
